import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { GetInstructorsResponse } from '../modal/instructor';

export interface GetInstructorsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const getInstructorsAPI = async (params?: GetInstructorsParams) => {
  const response = await baseAPI.get<GetInstructorsResponse>(
    `custom-form/studio/fields`,
    {
      params: {
        ...params,
        type: 'instructor',
      },
    },
  );
  return response.data;
};

export const getInstructorsQueryOptions = (params?: GetInstructorsParams) =>
  queryOptions({
    queryKey: [KEYS.INSTRUCTORS, params],
    queryFn: () => getInstructorsAPI(params),
    placeholderData: keepPreviousData,
  });

export const useGetInstructors = (params?: GetInstructorsParams) => {
  return useQuery(getInstructorsQueryOptions(params));
};
